import { useTranslation } from "react-i18next";

import { Copy } from "@/assets/icons/ds";
import { FieldRow } from "@/components/Portal/UserAccount/PersonalDetails/FieldRow/FieldRow";
import { useAlert } from "@/hooks/useAlert";
import { AlertTypes } from "@/utils/atoms";

/**
 * The "enter this key manually" fallback shown alongside the 2FA QR code,
 * shared by the initial app setup (`AuthenticatorAppForm`) and the
 * management "Change 2FA method" flow (`TwoFactorManualQrCodeField`) so
 * both render the identical, correctly-branded copy control.
 */
export const ManualKeyField = ({ manualCode }: { manualCode?: string }) => {
  const { t } = useTranslation();
  const showAlert = useAlert();

  const copyManualKey = () => {
    if (!manualCode) {
      return;
    }

    navigator.clipboard
      .writeText(manualCode)
      .then(() => {
        showAlert({
          type: AlertTypes.success,
          text: t("portal:authenticator.app.setup.step1.copied"),
        });
      })
      .catch(() => {
        showAlert({
          type: AlertTypes.error,
          text: t("portal:authenticator.app.setup.step1.copy-error"),
        });
      });
  };

  return (
    <FieldRow
      className="w-full"
      label={t("portal:authenticator.app.setup.step1.your-manual-key")}
      value={manualCode}
      wrapValue
      icon={
        <button
          type="button"
          className="flex shrink-0 items-center"
          onClick={copyManualKey}
          aria-label={t("translation:clipboardField.copy")}
        >
          <Copy className="h-6 w-6 text-foreground-primary" />
        </button>
      }
    />
  );
};
